import { render, staticRenderFns } from "./OrderAfterSalesStatus.vue?vue&type=template&id=031f63ab&scoped=true"
import script from "./OrderAfterSalesStatus.vue?vue&type=script&lang=js"
export * from "./OrderAfterSalesStatus.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./OrderAfterSalesStatus.vue?vue&type=style&index=0&id=031f63ab&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "031f63ab",
  "172af564"
  
)

export default component.exports